import { getPaywallEventPayload, PAYWALL_EVENT_ENDPOINT, sanitizeAnalyticsPayload } from './paywallAnalytics';

const KEY = 'payment_recovery_events_v1';
const TTL = 24 * 60 * 60 * 1000;
const names = new Set(['trial_payment_blocked', 'trial_payment_status_check',
  'trial_payment_status_result', 'trial_payment_recovered']);
const inFlight = new Set();
let queue = [];

function save() {
  try { sessionStorage.setItem(KEY, JSON.stringify(queue)); } catch (_) {}
}

// A small tab-local outbox: survives reload, never stores a Stripe secret.
function restore() {
  try {
    const stored = JSON.parse(sessionStorage.getItem(KEY) || '[]');
    if (!Array.isArray(stored)) return;
    queue = stored.slice(-30).filter(e => names.has(e.event_name) &&
      typeof e.payload?.occurred_at === 'number' && e.payload.occurred_at > Date.now() - TTL)
      .map(e => ({
        ...Object.fromEntries(['client_reference_id', 'event_name', 'paywall', 'route',
          'payment_path', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
          .filter(key => typeof e[key] === 'string')
          .map(key => [key, e[key].slice(0, 256)])),
        payload: sanitizeAnalyticsPayload(e.payload),
      })).filter(e => e.client_reference_id && e.payload.event_id);
  } catch (_) {}
}

export async function flushPaymentRecoveryEvents() {
  queue = queue.filter(e => e.payload.occurred_at > Date.now() - TTL).slice(-30);
  save();
  await Promise.all(queue.map(async event => {
    const id = event.payload.event_id;
    if (inFlight.has(id)) return;
    inFlight.add(id);
    try {
      const response = await fetch(PAYWALL_EVENT_ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(event), keepalive: true,
      });
      if (response.ok) {
        queue = queue.filter(e => e.payload.event_id !== id); save();
      }
    } catch (_) { /* Retry only on online, reload or the next recovery event. */ }
    finally { inFlight.delete(id); }
  }));
}

export function sendPaymentRecoveryEvent(eventName, options) {
  try {
    if (!names.has(eventName)) return;
    const event = getPaywallEventPayload({ ...options, eventName,
      payload: { ...options?.payload,
        event_id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`,
        occurred_at: Date.now() } });
    if (!event) return;
    queue.push(event); queue = queue.slice(-30); save();
    void flushPaymentRecoveryEvents();
  } catch (_) { /* Telemetry must never stop checkout, even with blocked storage. */ }
}

if (typeof window !== 'undefined') {
  restore();
  window.addEventListener('online', () => { void flushPaymentRecoveryEvents(); });
  if (queue.length) void flushPaymentRecoveryEvents();
}
